module.exports = __webpack_public_path__ + "static/media/ipad.351795a6.png";